import { Divider, Modal } from '@mantine/core'

import DNButton from 'src/components/Buttons/Button/DNButton'
import IconSwapArrows from 'src/icons/IconSwapArrows'

interface SwitchCompanyModalProps {
  opened: boolean
  applicantName: string
  companyName: string
  isSwitching?: boolean
  onCancel: () => void
  onConfirm: () => void
}

const SwitchCompanyModal = ({
  opened,
  applicantName,
  companyName,
  isSwitching = false,
  onCancel,
  onConfirm,
}: SwitchCompanyModalProps) => {
  return (
    <Modal
      opened={opened}
      onClose={onCancel}
      centered
      size="35%"
      withCloseButton={false}
    >
      <div className="flex flex-col gap-4">
        <IconSwapArrows className="h-10 w-10 rounded bg-doubleNickel-brand-50 fill-none stroke-doubleNickel-brand-600 p-2" />
        <div className="flex flex-col items-start">
          <div className="text-based font-semibold text-doubleNickel-gray-900">
            Switch to {companyName}?
          </div>
          <div className="text-sm text-doubleNickel-gray-700">
            {applicantName} belongs to {companyName}, which is not your active
            company. Switching will reload this page with {companyName} active.
          </div>
          <div className="mt-2 text-sm text-doubleNickel-warning-700">
            Your active company is shared across the whole app, so any other
            tabs you have open will switch to {companyName} and reload too.
          </div>
        </div>
        <Divider />
        <div className="flex w-full flex-row justify-end gap-3">
          <DNButton variant="outline" onClick={onCancel}>
            Cancel
          </DNButton>
          <DNButton
            variant="primary"
            onClick={onConfirm}
            loading={isSwitching}
            className="min-w-20"
          >
            Switch company
          </DNButton>
        </div>
      </div>
    </Modal>
  )
}

export default SwitchCompanyModal
